export default {
    en: "English",
    vi: "Vietnamese"
}